import type {
  DeprecatedPulseContextProviderConfig,
  PulseContextProviderConfig,
} from './types/index.js';

import { frontendConfig } from '../../system/config/frontend.server.js';

const isProduction = ['convox-production', 'convox-failover'].includes(
  frontendConfig.serverRuntime,
);

const providerStage: PulseContextProviderConfig['stage'] = isProduction
  ? 'Pro'
  : 'Pre';

const defaultDeprecatedPulseConfig: DeprecatedPulseContextProviderConfig = {
  ...frontendConfig.pulseConfig,
};

export { defaultDeprecatedPulseConfig, providerStage };
